import { Search, FileText, Wrench, Paintbrush, ThumbsUp } from 'lucide-react';

const steps = [
  {
    icon: Search,
    number: 1,
    title: 'Kostnadsfri besiktning',
    description: 'Vi besöker dig för att inspektera fönstrens skick och diskutera dina önskemål. Ingen förpliktelse.',
  },
  {
    icon: FileText,
    number: 2,
    title: 'Fast och tydlig offert',
    description: 'Du får en skriftlig offert med fast pris, tydlig specifikation och information om ROT-avdrag.',
  },
  {
    icon: Wrench,
    number: 3,
    title: 'Demontering & skydd',
    description: 'Vi tar hand om fönstren på plats eller i vår verkstad beroende på behov. Omgivningen skyddas noga.',
  },
  {
    icon: Paintbrush,
    number: 4,
    title: 'Förarbete & målning',
    description: 'Gammal färg skrapas bort, ytan slipas och grundas. Därefter appliceras flera lager färg för bästa hållbarhet.',
  },
  {
    icon: ThumbsUp,
    number: 5,
    title: 'Slutkontroll & nöjd kund',
    description: 'Vi går igenom resultatet tillsammans. Du godkänner arbetet först när du är helt nöjd.',
  },
];

export const ProcessSection = () => {
  return (
    <section id="process" className="section-padding bg-white" data-testid="process-section">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
          <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
            Arbetsgång
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-[#1F2937] mb-6">
            Så går fönstermålningen till
          </h2>
          <p className="text-base md:text-lg text-[#64748B]">
            Vi har en beprövad process som säkerställer ett felfritt resultat varje gång. 
            Från första kontakt till färdigt projekt – du är informerad hela vägen.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#E2E8F0] transform -translate-x-1/2" aria-hidden="true" />
          
          <div className="space-y-8 md:space-y-0">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={index}
                  className="relative md:flex md:items-center animate-fade-in-up"
                  style={{ animationDelay: `${index * 150}ms` }}
                  data-testid={`process-step-${index}`}
                >
                  {/* Mobile layout */}
                  <div className="md:hidden flex gap-4">
                    <div className="timeline-dot">
                      {step.number}
                    </div>
                    <div className="pb-8 border-l-2 border-[#E2E8F0] pl-6 ml-[-1px] last:border-0">
                      <h3 className="text-xl font-heading font-semibold text-[#1F2937] mb-2">
                        {step.title}
                      </h3>
                      <p className="text-[#64748B]">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  {/* Desktop layout */}
                  <div className={`hidden md:flex md:w-full items-center ${isEven ? '' : 'flex-row-reverse'}`}>
                    {/* Content */}
                    <div className={`w-5/12 ${isEven ? 'text-right pr-12' : 'text-left pl-12'}`}>
                      <div className={`bg-white p-6 border border-[#E2E8F0] inline-block ${isEven ? 'text-right' : 'text-left'} hover:shadow-lg transition-shadow duration-300`}>
                        <div className={`flex items-center gap-3 mb-3 ${isEven ? 'justify-end' : 'justify-start'}`}>
                          <div className={`w-10 h-10 bg-[#F1F5F9] flex items-center justify-center ${isEven ? 'order-2' : ''}`}>
                            <IconComponent className="w-5 h-5 text-[#2C3E50]" />
                          </div>
                          <h3 className="text-xl font-heading font-semibold text-[#1F2937]">
                            {step.title}
                          </h3>
                        </div>
                        <p className="text-[#64748B] text-sm">
                          {step.description}
                        </p>
                      </div>
                    </div>

                    {/* Center dot */}
                    <div className="w-2/12 flex justify-center">
                      <div className="timeline-dot">
                        {step.number}
                      </div>
                    </div>

                    {/* Empty space */}
                    <div className="w-5/12" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
